import classNames from 'classnames'
import { createElement } from 'react'

import { Text } from '../../components/Text'
import { Icon, type SvgProps, CloseIconButton } from '../../components'
import { useTranslation } from 'react-i18next'
import { ToastProps, ToastSeverity } from './types'

const severityIconMap: {
  [key in ToastSeverity]: React.ComponentType<SvgProps>
} = {
  success: Icon.CheckOutline,
  critical: Icon.CloseCircle,
  info: Icon.Information,
  warning: Icon.Warning,
}

export const Toast = ({
  className,
  severity,
  title,
  message,
  dismissable,
  onDismiss,
  ...props
}: ToastProps) => {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      aria-live="off"
      className={classNames(
        'bg-primary px-3 py-3 max-w-full w-full md:max-w-[353px] w-max flex gap-x-2 items-start shadow-[0_4px_16px_0_rgba(0,0,0,0.12)]',
        className,
      )}
      {...props}
    >
      <div className="w-6 h-6">
        {createElement(severityIconMap[severity], {
          className: 'w-full h-full text-black',
        })}
      </div>
      <Text>
        {title && <b>{title} </b>}
        {message}
      </Text>
      {dismissable && (
        <CloseIconButton
          aria-label={t('action.close', { defaultValue: 'Close' })}
          onClick={onDismiss}
          className="ml-auto bg-transparent hover:bg-transparent !w-5 !h-5"
        />
      )}
    </div>
  )
}
